export default class Copy {

	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Copy;
		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		$(document).on('click', '.js-copy-to-clipboard', function(e) {
			e.preventDefault();

			self.clipboardCopy($(this).data('copy'));
		});
	}

	clipboardCopy(value) {
		const self = this;

		navigator.clipboard.writeText(value).then(function() {
			$('body').append('<div class="form-fixed-response"><div class="container"><div class="row"><div class="col-24.col-md-12 offset-md-6 col-xxl-8 offset-xxl-8"><div class="form-error-message alert alert-success">Link copied</div></div></div></div></div>');

	        $('.form-fixed-response').fadeIn(200);
		}, function() {
			$('body').append('<div class="form-fixed-response"><div class="container"><div class="row"><div class="col-24.col-md-12 offset-md-6 col-xxl-8 offset-xxl-8"><div class="form-error-message alert alert-error">Error Occurred</div></div></div></div></div>');

			$('.form-fixed-response').fadeIn(200);
		});


        setTimeout(function() {
	        $('.form-fixed-response').fadeOut(300, function(){
	            $(this).remove();
	        });
	    }, 2000);
	}
}
